// extracted by mini-css-extract-plugin
export default {"image_ctn":"ImageSlider_image_ctn__6rC9W","slider":"ImageSlider_slider__6TKRi","slide":"ImageSlider_slide__VXHX6"};